/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface RejectCustomerMergeRequest
 */
export interface RejectCustomerMergeRequest {
    /**
     * 
     * @type {number}
     * @memberof RejectCustomerMergeRequest
     */
    eventId?: number;
}

/**
 * Check if a given object implements the RejectCustomerMergeRequest interface.
 */
export function instanceOfRejectCustomerMergeRequest(value: object): boolean {
    return true;
}

export function RejectCustomerMergeRequestFromJSON(json: any): RejectCustomerMergeRequest {
    return RejectCustomerMergeRequestFromJSONTyped(json, false);
}

export function RejectCustomerMergeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectCustomerMergeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
    };
}

export function RejectCustomerMergeRequestToJSON(value?: RejectCustomerMergeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventId': value['eventId'],
    };
}

